module.exports = __webpack_public_path__ + "static/media/bamba-uncovered-illustration.395506a0.svg";